import { Legend } from "../../molecules/Legends";
import { DataMonitoringList } from "../../molecules/DataMonitoringList";
import { DashboardContent } from "../../organisms/Contents/DashboardContent";
import * as S from "./DashboardTemplate.style";
import { EquipMonitoringList } from "../../molecules/EquipMonitoringList";
import { useQuery } from "@tanstack/react-query";
import {
  GET_DATA_MONITORING,
  GET_SHIP_OPERATION_STATUS,
} from "../../../common/query-keys";
import { useRecoilValue } from "recoil";
import { currentShipState } from "../../../common/states/ship";
import { ShipOperationStatus } from "../../../common/types/ship";
import { request } from "../../../common/api";
import { DataMonitoringType } from "../../../common/types/dataMonitoring";
import { useEffect, useState } from "react";
import { Loading } from "../../atoms/Loading";

export const DashboardTemplate = () => {
  const currentShip = useRecoilValue(currentShipState);

  /**
   * 메인화면 전체 데이터
   * ? fetch 코드 수정 완료 2025.05.23
   * ! 백엔드 메인 쿼리 수정 필요
   */
  const { data: shipOperationStatus, isLoading } = useQuery({
    queryKey: [
      GET_SHIP_OPERATION_STATUS,
      currentShip.shipTypeNo,
      currentShip.shipNo,
    ],
    queryFn: async () => {
      return await request<ShipOperationStatus>({
        method: "GET",
        url: `/ship-info/operation/status`,
        params: {
          shipTypeNo: currentShip.shipTypeNo,
          shipNo: currentShip.shipNo,
        },
      });
    },
    refetchInterval: 15000,
  });

  if (isLoading) {
    return <Loading />; // 최초 로드시에만 Loading 컴포넌트 표시
  }

  return (
    <S.DashboardTemplate>
      {/* 장비 운용현황 */}
      <DashboardContent
        title={
          <S.DashboardShipOperationLayout>
            <p>장비 운용현황</p>
          </S.DashboardShipOperationLayout>
        }
        legend={
          <Legend
            title="함정 운항정보"
            type="sailing-info"
            shipOperationStatus={shipOperationStatus}
          />
        }
      >
        <EquipMonitoringList
          shipOperationStatus={shipOperationStatus}
          currentShip={currentShip}
        />
      </DashboardContent>
    </S.DashboardTemplate>
  );
};
